import { useToastStore } from '../stores/toastStore';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import clsx from 'clsx';

export default function Toaster() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[1000] flex flex-col gap-2 max-w-sm w-[calc(100%-2rem)] sm:w-auto">
      {toasts.map((t) => {
        const Icon = t.type === 'error' ? AlertCircle : t.type === 'success' ? CheckCircle : Info;
        return (
          <div
            key={t.id}
            role="alert"
            className={clsx(
              'flex items-start gap-2 rounded-lg shadow-lg px-4 py-3 text-sm text-white',
              t.type === 'error' && 'bg-danger-600',
              t.type === 'success' && 'bg-success-600',
              t.type === 'info' && 'bg-slate-800'
            )}
          >
            <Icon className="w-4 h-4 mt-0.5 shrink-0" />
            <span className="flex-1 whitespace-pre-line">{t.message}</span>
            <button onClick={() => dismiss(t.id)} className="shrink-0 opacity-80 hover:opacity-100">
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
